import {
  getSimulationFeedbacks,
  getSimulationById,
  getSimulationByIdDashboard,
  createSimulation,
  getLastSimulation,
  getSimulation,
  createQuickPratice,
  createWebScraping,
  getQuickPratice,
  getCoachTivy,
  inSimulationFeedback,
  getSimulationByUser,
  deleteSimulationById,
  getCoachTivyFeedbacks,
  createCoachTivyFeedbacks,
  getDonorSimulationFeedbacks,
  createDonorSimulationFeedbacks,
  saveTranscription, 
} from '@/store/actions/forms';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@/store';

interface SimulationState {
  getSimulationByUserLoading: boolean;
  // Add other properties here as needed
}

const initialLoginState = {
  errorMessage: '',
  formData: '',
  isStart: false,
  Assistant: '',
  isPrompt: '',
  feedbacks: '',
  feedback_loading: false,
  feedback_data: '',
  setNewFeedbacksData: '',
  setSimulationLoading: false,
  getOneSimulation: '',
  quick_add: false,
  getNewFeedbackLoading: true,
  getNewFeedbacks: '',
  getCoachTivyFeedbackLoading: false,
  getCoachTivyFeedback: '',
  coachTivyFeedbackGenerated: false,
  getDonorSimulationFeedbackLoading: false,
  getDonorSimulationFeedback: '',
  donorSimulationFeedbackGenerated: false,
  getAllSimualton: '',
  getSimulationLoading: false,
  transcriptLoading: false,
  quickAdd: false,
  getQuickPratice: '',
  getQuickPraticeLoading: false,
  getCoachTivy: '',
  getCoachTivyLoading: false,
  simulationType: '',
  getLastSimulations: '',
  getLastSimulationLoading: false,
  userInfo: false,
  getSimulationByUserLoading: false,
  getSimualtionByUser: [] as any[],
  setTranscriptsData: '',
  setTotalTimeData: 0,
  chatHistory: [],
  hasPastSimulations: false,
  confirmedNavigation: false,
};

export const userInfoRedirect = createAsyncThunk<any, any>(
  'simulation/userInfo',
  async (payload: any) => {
    return payload;
  },
);

export const FormData = createAsyncThunk<any, any>(
  'simulation/formData',
  async (payload: string) => {
    return payload;
  },
);

export const isStartData = createAsyncThunk<any, any>(
  'simulation/isStart',
  async (payload: any) => {
    return payload;
  },
);

export const saveChatData = createAsyncThunk<any, any>(
  'simulation/chatHistory',
  async (payload: any) => {
    return payload;
  },
);
export const assistandSelection = createAsyncThunk<any, any>(
  'simulation/Assistant',
  async (payload: string) => {
    return payload;
  },
);

export const Prompt = createAsyncThunk<any, any>(
  'simulation/isPrompt',
  async (payload: any) => {
    return payload;
  },
);

export const clearFeedbacks = createAsyncThunk<any, any>(
  'simulation/feedbacks',
  async (payload: any) => {
    return payload;
  },
);

export const clearQuickPratcie = createAsyncThunk<any, any>(
  'simulation/getQuickPratice',
  async (payload: any) => {
    return payload;
  },
);

export const clearCoachTivy = createAsyncThunk<any, any>(
  'simulation/getCoachTivy',
  async (payload: any) => {
    return payload;
  },
);

export const clearLastSimulation = createAsyncThunk<any, any>(
  'simulation/getLastSimulations',
  async (payload: any) => {
    return payload;
  },
);

export const getSimulationType = createAsyncThunk<any, any>(
  'simulation/simulationType',
  async (payload: any) => {
    return payload;
  },
);

export const clearPostFeedbacks = createAsyncThunk<any, any>(
  'simulation/getNewFeedbacks',
  async (payload: any) => {
    return payload;
  },
);

export const clearWebScraping = createAsyncThunk<any, any>(
  'simulation/getWebScrappingData',
  async (payload: any) => {
    return payload;
  },
);

export const cleargetOneSimulation = createAsyncThunk<any, any>(
  'simulation/getOneSimulation',
  async (payload: string) => {
    return payload;
  },
);

export const cleargetCoachTivyFeedback = createAsyncThunk<any, any>(
  'simulation/getCoachTivyFeedback',
  async (payload: string) => {
    return payload;
  },
);

export const cleargetDonorSimulationFeedback = createAsyncThunk<any, any>(
  'simulation/getDonorSimulationFeedback',
  async (payload: string) => {
    return payload;
  },
);

export const feedbackLoadData = createAsyncThunk<any, any>(
  'simulation/getNewFeedbackLoading',
  async (payload: boolean) => {
    return payload;
  },
);

export const confirmNavigation = createAsyncThunk<any, any>(
  'simulation/confirmedNavigation',
  async (payload: boolean) => {
    return payload;
  },
);

export const simulationSlice = createSlice({
  name: 'simulation',
  initialState: initialLoginState,
  reducers: {},

  extraReducers: (builder: any) => {
    builder
      .addCase(getSimulationType.fulfilled, (state: any, { payload }: any) => {
        state.simulationType = payload;
      })

      .addCase(cleargetOneSimulation.fulfilled, (state: any, { payload }: any) => {
        state.getOneSimulation = payload;
      })

      .addCase(cleargetCoachTivyFeedback.fulfilled, (state: any, { payload }: any) => {
        state.getCoachTivyFeedback = payload;
        state.coachTivyFeedbackGenerated = false;
      })

      .addCase(cleargetDonorSimulationFeedback.fulfilled, (state: any, { payload }: any) => {
        state.getDonorSimulationFeedback = payload;
        state.donorSimulationFeedbackGenerated = false;
      })

      .addCase(getLastSimulation.fulfilled, (state: any, { payload }: any) => {
        state.getLastSimulations = payload?.data;
        state.getLastSimulationLoading = false;
        state.getQuickPraticeLoading = false;
        state.getCoachTivyLoading = false;
      })

      .addCase(getLastSimulation.pending, (state: any, { payload }: any) => {
        state.getLastSimulations = '';
        state.getQuickPraticeLoading = true;
        state.getLastSimulationLoading = true;
        state.getCoachTivyLoading = true;
      })

      .addCase(getLastSimulation.rejected, (state: any, { payload }: any) => {
        state.getLastSimulationLoading = false;
        state.getQuickPraticeLoading = false;
        state.getCoachTivyLoading = false;
      })

      .addCase(getQuickPratice.fulfilled, (state: any, { payload }: any) => {
        state.getQuickPratice = payload?.data;
        state.getLastSimulationLoading = false;
        state.getQuickPraticeLoading = false;
        state.getCoachTivyLoading = false;
      })

      .addCase(getQuickPratice.pending, (state: any, { payload }: any) => {
        state.getQuickPratice = '';

        state.getQuickPraticeLoading = true;
        state.getLastSimulationLoading = true;
        state.getCoachTivyLoading = true;
      })

      .addCase(getQuickPratice.rejected, (state: any, { payload }: any) => {
        state.getLastSimulationLoading = false;
        state.getQuickPraticeLoading = false;
        state.getCoachTivyLoading = false;
      })

      .addCase(getCoachTivy.fulfilled, (state: any, { payload }: any) => {
        state.getCoachTivy = payload?.data;
        state.getLastSimulationLoading = false;
        state.getQuickPraticeLoading = false;
        state.getCoachTivyLoading = false;
      })

      .addCase(getCoachTivy.pending, (state: any, { payload }: any) => {
        state.getCoachTivy = '';

        state.getCoachTivyLoading = true;
        state.getQuickPraticeLoading = true;
        state.getLastSimulationLoading = true;
      })

      .addCase(getCoachTivy.rejected, (state: any, { payload }: any) => {
        state.getLastSimulationLoading = false;
        state.getQuickPraticeLoading = false;
        state.getCoachTivyLoading = false;
      })

      .addCase(createQuickPratice.fulfilled, (state: any, { payload }: any) => {
        state.quickAdd = false;
      })

      .addCase(createQuickPratice.pending, (state: any, { payload }: any) => {
        state.quickAdd = true;
      })

      .addCase(createQuickPratice.rejected, (state: any, { payload }: any) => {
        state.quickAdd = false;
      })

      .addCase(createWebScraping.fulfilled, (state: any, { payload }: any) => {
        state.getWebScrappingData = payload;
      })

      .addCase(createWebScraping.pending, (state: any, { payload }: any) => {
        state.getWebScrappingData = '';
      })

      .addCase(createWebScraping.rejected, (state: any, { payload }: any) => {
        state.getWebScrappingData = '';
      })

      .addCase(clearWebScraping.fulfilled, (state: any, { payload }: any) => {
        state.getWebScrappingData = '';
      })

      .addCase(getSimulation.fulfilled, (state: any, { payload }: any) => {
        state.getAllSimualton = payload;
        state.getSimulationLoading = false;
      })

      .addCase(getSimulation.pending, (state: any, { payload }: any) => {
        state.getSimulationLoading = true;
      })

      .addCase(getSimulation.rejected, (state: any, { payload }: any) => {
        state.getSimulationLoading = false;
      })

      .addCase(
        getSimulationByIdDashboard.fulfilled,
        (state: any, { payload }: any) => {
          state.transcriptLoading = false
          state.formData = payload?.simulation;
          state.setNewFeedbacksData = payload?.feedback;
           
          state.setTranscriptsData = payload?.callDetails;
        },
      )
      .addCase(
        getSimulationByIdDashboard.pending,
        (state: any, { payload }: any) => { 
           state.transcriptLoading = true
          state.setTranscriptsData = '';
         },
      )
      .addCase(
        getSimulationByIdDashboard.rejected,
        (state: any, { payload }: any) => { 
          state.transcriptLoading = false
        },
      )
      .addCase(getSimulationByUser.pending, (state: SimulationState) => {
        state.getSimulationByUserLoading = true;
      })
      .addCase(
        getSimulationByUser.fulfilled,
        (state: any, { payload }: any) => {
          state.getSimualtionByUser = payload?.data;
          state.setTotalTimeData = payload?.totalDuration;
          state.getSimulationByUserLoading = false;
          state.hasPastSimulations = payload?.data?.length > 0;
        },
      )
      .addCase(getSimulationByUser.rejected, (state: any) => {
        state.getSimulationByUserLoading = true;
      })
      .addCase(getSimulationById.fulfilled, (state: any, { payload }: any) => {
        state.formData = payload?.simulation;
        state.setNewFeedbacksData = payload?.feedback;
         
        state.setTranscriptsData = payload?.callDetails;
      })

      .addCase(getSimulationById.rejected, (state: any) => {
        state.getSimulationByUserLoading = true;
      })

      .addCase(createSimulation.fulfilled, (state: any, { payload }: any) => {
        state.getOneSimulation = payload?.data;
      })

      .addCase(createSimulation.pending, (state: any, { payload }: any) => {
        state.getCoachTivyFeedbackLoading = true;
        state.getDonorSimulationFeedbackLoading = true;
      })

      .addCase(createSimulation.rejected, (state: any, { payload }: any) => {
        state.getCoachTivyFeedbackLoading = false;
        state.getDonorSimulationFeedbackLoading = false;
      })

      .addCase(feedbackLoadData.fulfilled, (state: any, { payload }: any) => {
        state.getNewFeedbackLoading = true;
      })

      .addCase(
        getSimulationFeedbacks.pending,
        (state: any, { payload }: any) => {
          state.getNewFeedbacks = '';
          state.getNewFeedbackLoading = true;
        },
      )

      .addCase(
        getSimulationFeedbacks.fulfilled,
        (state: any, { payload }: any) => {
          state.getNewFeedbacks = payload?.data;
          state.getNewFeedbackLoading = false;
        },
      )

      .addCase(
        getSimulationFeedbacks.rejected,
        (state: any, { payload }: any) => {
          state.getNewFeedbackLoading = false;
        },
      )

      .addCase(
        getCoachTivyFeedbacks.pending,
        (state: any, { payload }: any) => {
          state.getCoachTivyFeedback = '';
          state.getCoachTivyFeedbackLoading = true;
        },
      )

      .addCase(
        getCoachTivyFeedbacks.fulfilled,
        (state: any, { payload }: any) => {
          state.getCoachTivyFeedback = payload;
          state.getCoachTivyFeedbackLoading = false;
        },
      )

      .addCase(
        getCoachTivyFeedbacks.rejected,
        (state: any, { payload }: any) => {
          state.getCoachTivyFeedbackLoading = false;
        },
      )

      .addCase(
        getDonorSimulationFeedbacks.pending,
        (state: any, { payload }: any) => {
          state.getDonorSimulationFeedback = '';
          state.getDonorSimulationFeedbackLoading = true;
        },
      )

      .addCase(
        getDonorSimulationFeedbacks.fulfilled,
        (state: any, { payload }: any) => {
          state.getDonorSimulationFeedback = payload;
          state.getDonorSimulationFeedbackLoading = false;
        },
      )

      .addCase(
        getDonorSimulationFeedbacks.rejected,
        (state: any, { payload }: any) => {
          state.getDonorSimulationFeedbackLoading = false;
        },
      )

      .addCase(
        createCoachTivyFeedbacks.pending,
        (state: any, { payload }: any) => {
          state.getCoachTivyFeedbackLoading = true;
        },
      )

      .addCase(
        createCoachTivyFeedbacks.fulfilled,
        (state: any, { payload }: any) => {
          state.coachTivyFeedbackGenerated = payload?.success;
        },
      )

      .addCase(
        createCoachTivyFeedbacks.rejected,
        (state: any, { payload }: any) => {
          state.getCoachTivyFeedbackLoading = false;
        },
      )

      .addCase(
        saveTranscription.pending,
        (state: any, { payload }: any) => {
          state.getDonorSimulationFeedbackLoading = true;
        },
      )

      .addCase(
        saveTranscription.fulfilled,
        (state: any, { payload }: any) => {},
      )

      .addCase(
        saveTranscription.rejected,
        (state: any, { payload }: any) => {
          state.getDonorSimulationFeedbackLoading = false;
        },
      )

      .addCase(
        createDonorSimulationFeedbacks.pending,
        (state: any, { payload }: any) => {
          state.getDonorSimulationFeedbackLoading = true;
        },
      )

      .addCase(
        createDonorSimulationFeedbacks.fulfilled,
        (state: any, { payload }: any) => {
          state.donorSimulationFeedbackGenerated = payload?.success;
        },
      )

      .addCase(
        createDonorSimulationFeedbacks.rejected,
        (state: any, { payload }: any) => {
          state.getDonorSimulationFeedbackLoading = false;
        },
      )

      .addCase(
        inSimulationFeedback.fulfilled,
        (state: any, { payload }: any) => {
          state.feedbacks = payload;
        },
      )

      .addCase(FormData.fulfilled, (state: any, { payload }: any) => {
        state.formData = payload;
      })

      .addCase(isStartData.fulfilled, (state: any, { payload }: any) => {
        state.isStart = payload;
      })

      .addCase(saveChatData.fulfilled, (state: any, { payload }: any) => {
        state.chatHistory = payload;
      })

      .addCase(assistandSelection.fulfilled, (state: any, { payload }: any) => {
        state.Assistant = payload;
      })

      .addCase(clearQuickPratcie.fulfilled, (state: any, { payload }: any) => {
        state.getQuickPratice = payload;
      })

      .addCase(clearCoachTivy.fulfilled, (state: any, { payload }: any) => {
        state.getCoachTivy = payload;
      })

      .addCase(
        clearLastSimulation.fulfilled,
        (state: any, { payload }: any) => {
          state.getLastSimulations = payload;
        },
      )
      .addCase(userInfoRedirect.fulfilled, (state: any, { payload }: any) => {
        state.userInfo = payload;
      })

      .addCase(Prompt.fulfilled, (state: any, { payload }: any) => {
        state.isPrompt = payload;
      })

      .addCase(clearPostFeedbacks.fulfilled, (state: any, { payload }: any) => {
        state.getNewFeedbacks = payload;
      })

      .addCase(deleteSimulationById.pending, (state: any, { payload }: any) => {
        state.getSimulationLoading = true;
      })

      .addCase(
        deleteSimulationById.fulfilled,
        (state: any, { payload }: any) => {
          state.getSimulationLoading = false;
        },
      )

      .addCase(
        deleteSimulationById.rejected,
        (state: any, { payload }: any) => {
          state.getSimulationLoading = false;
        },
      )

      .addCase(confirmNavigation.fulfilled, (state: any, { payload }: any) => {
        state.confirmedNavigation = payload;
      });
  },
});

export default simulationSlice.reducer;

export const selectHasPastSimulations = (state: RootState) => state.simulation.hasPastSimulations;
